import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header, { headerItemsLabels } from '../../../Common/Header/header';
import { gridsNames } from '../../../../enums/gridsNames';
import { FetchEntitiesFilters } from '../../../../enums/fetchEntitiesFilters';
import { ImportTypes, ImportAcceptFileTypes } from '../../../../enums/importTypes';
import GroupsGrid from './GroupsGrid/groupsGrid';
import { getEnumValue, enumTypes } from '../../../../utils/enumHelper';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import {
  getLocationAssetTypes,
  getLocationAssetTypesForPrintPdfLabels,
  isTransitArea
} from '../../../../utils/locationHelper';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';

require('./groupsView.scss');

export default class GroupsView extends Component {

  constructor (props) {
    super(props);
    this.labels = createLabelHelper('mat.locationpage.view.assets.');
  }

  getDialogConfig = () => {
    return {
      boEntityFilter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.ON_LOCATION],
      entitiesTypes: [getEnumValue(enumTypes.OBJECT_TYPE)('GROUP')],
      preselectedAssets: this.props.sSelectedRowsData,
    };
  };

  getMoveAssetsDialogConfig = () => {
    let {sSelectedRowsData, sLocationDetails} = this.props;
    return {
      boEntityFilter: [
        FetchEntitiesFilters.ACTIVE,
      ],
      entitiesTypes: sSelectedRowsData?.size > 0 ? [getEnumValue(enumTypes.OBJECT_TYPE)('GROUP')] :
        getLocationAssetTypes(sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('GROUP')),
      preselectedAssets: sSelectedRowsData,
    };
  };

  getBringAssetsDialogConfig = () => {
    let {sLocationDetails} = this.props;
    return {
      boEntityFilter: [
        FetchEntitiesFilters.ACTIVE,
      ],
      entitiesTypes: getLocationAssetTypes(sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('GROUP')),
    };
  };

  getImportConfig = () => {
    return {
      importTypes: [ImportTypes.IMPORT_GROUPS],
      acceptFileTypes: [ImportAcceptFileTypes.CSV, ImportAcceptFileTypes.JSON],
      parentComponent: this.onRefreshAll,
      shouldIncludeLocation: false, //import is done from a location , the import file locationId column is optional.
      showPrintLabels: true,
    };
  };

  getPrintPdfLabelsDialogConfig = () => {
    return {
      boEntityFilter: [FetchEntitiesFilters.ALL],
      preselectedAssets: this.props.sSelectedRowsData,
      entitiesTypes: getLocationAssetTypesForPrintPdfLabels(this.props.sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('GROUP')),
    };
  };

  getAddToGroupDialogConfig = () => {
    let {sSelectedRowsData, sLocationDetails} = this.props;
    return {
      boEntityFilter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.ON_LOCATION],
      preselectedAssets: sSelectedRowsData,
      entitiesTypes: sSelectedRowsData?.size > 0 ? [getEnumValue(enumTypes.OBJECT_TYPE)('GROUP')] :
        getLocationAssetTypes(sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('GROUP')),
    };
  };

  getEditLengthDialogConfig = () => {
    let payload = this.getDialogConfig();
    payload.editLengthOnly = true;
    return payload;
  };

  isMoveToAvailable = (data) => {
    return data?.every(item => item.assetStatus === getEnumValue(enumTypes.ASSET_STATUS)('ACTIVE'));
  }

  isMarkAsReceivedAvailable = (data) => {
    return data?.every(item => item.assetStatus === getEnumValue(enumTypes.ASSET_STATUS)('TRANSIENT') ||
                               item.assetStatus === getEnumValue(enumTypes.ASSET_STATUS)('MISSING'));
  }

  onRefreshAll = () => {
    this.props.actions?.reloadParentComponent();
  };

  getHeaderItems() {
    let { actions, sHasRows, sSelectedRowsData, sLocationDetails, loading } = this.props;

    let dialogConfig = this.getDialogConfig();
    let importConfig = this.getImportConfig();

    let items = {
      title: this.labels.get('title.groups'),
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
          actionData: {gridName: gridsNames.LOCATION_ASSET_GROUPS}
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: this.onRefreshAll,
          tooltip: headerItemsLabels.REFRESH_ALL,
          disabled: loading,
        },
        {
          id: 'moveTo',
          label: headerItemsLabels.MOVE_TO,
          icon: 'pl pl-move-assets',
          counter: sSelectedRowsData.size,
          action: actions.headerActions.onMenuItemMoveToClick,
          actionData: this.getMoveAssetsDialogConfig(sSelectedRowsData),
          disabled: loading || !this.isMoveToAvailable(sSelectedRowsData),
        },
        ...( !isTransitArea(sLocationDetails)
          ? [
              {
                id: 'bringHere',
                label: headerItemsLabels.BRING_HERE,
                icon: 'pl pl-bring-assets',
                action: actions.headerActions.onMenuItemBringHereClick,
                actionData: this.getBringAssetsDialogConfig(),
                disabled: loading,
              },
            ]
          : []),
      ],

      kebab: {
        disabled: loading,
        menuItems:
         isTransitArea(sLocationDetails) ?
           [{
             id: 'markGroupsAsReceived',
             label: headerItemsLabels.MARK_AS_RECEIVED,
             action: actions.headerActions.markAsReceived,
             disabled: sSelectedRowsData?.size === 0 || !this.isMarkAsReceivedAvailable(sSelectedRowsData),
             actionData: {
               actionData: sSelectedRowsData,
               parentComponent: this.onRefreshAll,
             },
           },]
           :
          [
          ...(PermissionManager.hasCreateAssetsPermissions()
            ? [
                {
                  id: 'createGroup',
                  label: headerItemsLabels.CREATE_GROUP,
                  action: actions.headerActions.onCreateGroupClick,
                  // actionData: this.getDialogConfig
                },
              ]
            : []),
          {
            id: 'ungroup',
            label: headerItemsLabels.UNGROUP,
            action: actions.headerActions.onUngroupClick,
            disabled: !sHasRows || !sSelectedRowsData || sSelectedRowsData.size !== 1 || sSelectedRowsData.get(0)?.availability === 'AVAILABLE',
            actionData: sSelectedRowsData,
          },

          ...(PermissionManager.hasArchiveAssetsPermissions()
            ? [
                {
                  id: 'archive',
                  label: headerItemsLabels.ARCHIVE,
                  action: actions.headerActions.onMenuItemArchiveClick,
                  actionData: dialogConfig,
                  disabled: !sHasRows,
                },
              ]
            : []),

          {
            id: 'export',
            label: headerItemsLabels.EXPORT_GROUPS_LIST,
            action: actions.headerActions.export,
            actionData: { gridName: gridsNames.LOCATION_ASSET_GROUPS },
            disabled: !sHasRows,
          },

          {
            id: 'exportGroupsReport',
            label: headerItemsLabels.EXPORT_GROUP_REPORT,
            action: actions.headerActions.onExportContainerReportClick,
            actionData: sSelectedRowsData,
            disabled: !sHasRows || !sSelectedRowsData || sSelectedRowsData.size === 0,
          },

          ...(PermissionManager.hasGroupAssetPermissions() &&
          PermissionManager.getOrgPreferences().groupsEnabled
            ? [
                {
                  id: 'addToGroup',
                  label: headerItemsLabels.ADD_TO_GROUP,
                  disabled: !sHasRows,
                  action: actions.headerActions.onAddToGroupDialogClick,
                  actionData: this.getAddToGroupDialogConfig(),
                },
              ]
            : []),

          ...(PermissionManager.hasEditAttributesPermissions()
            ? [
                {
                  id: 'editAttributes',
                  label: headerItemsLabels.EDIT_ATTRIBUTES,
                  disabled: !sHasRows,
                  action: actions.headerActions.onMenuItemEditAssetAttributesClick,
                  actionData: dialogConfig,
                },
              ]
            : []),

          ...(PermissionManager.hasImportAssetsPermissions()
            ? [
                {
                  id: 'importGroups',
                  label: headerItemsLabels.IMPORT_GROUPS,
                  action: actions.headerActions.importItems,
                  actionData: importConfig,
                },
              ]
            : []),

          {
            id: 'printRfidTags',
            label: headerItemsLabels.PRINT_RFID_TAGS,
            action: actions.headerActions.onMenuItemPrintRfidTagsClick,
            actionData: dialogConfig,
            disabled: !sHasRows,
          },

          ...(PermissionManager.getOrgPreferences().printZplGenericAssetEnabled
            ? [
                {
                  id: 'printEmptyTags',
                  label: headerItemsLabels.PRINT_EMPTY_TAGS,
                  action: actions.headerActions.onMenuItemPrintEmptyRfidTagsClick,
                },
              ]
            : []),

          {
            id: 'printPdfLabels',
            label: headerItemsLabels.PRINT_LABEL,
            action: actions.headerActions.onMenuItemPrintLabelClick,
            actionData: this.getPrintPdfLabelsDialogConfig(),
          },
        ],
      },
    };

    return items;
  }

  render() {
    let headerItems = this.getHeaderItems();
    return (
      <div className="groups-view">
        <Header {...headerItems} />

        <GroupsGrid actions={{...this.props.actions.assetsGroupsGridActions, ...this.props.actions.fetchEntitiesActions}}
          locationDetails={this.props.sLocationDetails}
          cellAction={this.props.actions.getAssetRelatedAssets}
        />
      </div>
    );
  }
}

GroupsView.propTypes = {
  actions: PropTypes.object.isRequired,
  sHasRows: PropTypes.bool.isRequired,
  sSelectedRowsData: PropTypes.object,
  sLocationDetails: PropTypes.object.isRequired,
};
